import React, { useMemo } from 'react';
import { createApiClient } from '@shared/api/client/api-client';
import { createApiServices } from '@shared/api/lib/services';
import { createSwrFetcher } from '@shared/api/swr/fetcher';
import { ToastProvider } from '@shared/ui';
import { SecondFactorProvider } from '@features/security';
import { ApiProvider } from '@shared/api/api-context';
import { SWRProvider } from './swr';

import { env } from '@shared/config/env';

interface AppProvidersProps {
  children: React.ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  const services = useMemo(() => {
    const client = createApiClient({ baseURL: env.API_BASE_URL });
    return createApiServices(client);
  }, []);

  const swrValue = useMemo(
    () => ({
      fetcher: createSwrFetcher(services),
    }),
    [services]
  );

  return (
    <ApiProvider services={services}>
      <SWRProvider value={swrValue}>
        <ToastProvider>
          <SecondFactorProvider>{children}</SecondFactorProvider>
        </ToastProvider>
      </SWRProvider>
    </ApiProvider>
  );
}
